<template>
  <router-link :to="link">
    <v-list-item
      class="item-list ma-0"
      :class="[isSubListItem ? 'sub-list-item' : '']"
      :active="isActive"
      :active-color="'#bd9478'"
      min-height="50"
      :rounded="rounded"
      :value="value"
      :title="title"
      link
    >
      <template v-slot:prepend>
        <v-icon v-if="icon" :color="iconColor" :icon="icon"></v-icon>
      </template> </v-list-item
  ></router-link>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    isSubListItem: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    value: {
      type: String,
    },
    icon: {
      type: String,
    },
    link: {
      type: String,
      default: "",
    },
    iconColor: {
      type: String,
      default: "#2C2C2C",
    },
    textColor: {
      type: String,
      default: "black",
    },
    bgColor: {
      type: String,
      default: "#E6E6E6",
    },
    rounded: {
      type: String,
      default: "0",
    },
  },
};
</script>

<style lang="scss">
.item-list {
  padding-right: 15px;
  .v-list-item__spacer {
    width: 4px !important;
  }

  .v-list-item-title {
    font-size: $mediumTextSize !important;
  }

  &:hover {
    background-color: #bd9478 !important;
    color: white !important;

    .v-icon {
      color: white !important;
    }
  }
}
</style>

<style lang="scss">
.sub-list-item {
  .v-list-item-title {
    padding-right: 10px;
  }
}
</style>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
}
</style>
